<rs-modal #modal (show)="show($event)" [config]="modalConfig">
  @if (procData) {
    <div class="card m-4">
      <ul>
        @for (procedure of procData.config.procedures; track procedure.procedureCode) {
          <li>
            {{ procedure.procedureCode }} - {{ procedure.name | translate }}
          </li>
        }
      </ul>
    </div>
  }
</rs-modal>
